import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { StyleSheetManager } from 'styled-components'
import { RootBox, SubsetBox } from './components'
import { StyledBox, StyledBoxContainer } from './styled'
import { BoxProps } from './types'

export const Box: React.FC<BoxProps> = ({
  root = false,
  visible = true,
  nest = false,
  title,
  children,
  className,
  ...args
}) => {
  const [rootBox, setRootBox] = useState<Element | null>(
    document.querySelector('.root-box'),
  )
  const [portal, setPortal] = useState<Element | null>(
    document.getElementById('box-portal'),
  )
  const prev = useRef(false)

  const removeStyleSheet = (el: HTMLElement) => {
    if (!el) return
    const styled = el.querySelector('style')
    if (styled && !styled.dataset.styled) {
      el.removeChild(styled)
    }
    const styledComps = el.querySelectorAll('style[data-styled="active"]')
    if (styledComps.length > 1) {
      ;[...styledComps]
        .slice(0, styledComps.length - 1)
        .forEach((styled) => el.removeChild(styled))
    }
  }

  useEffect(() => {
    const el = document.querySelector('.root-box')
    setRootBox(el)
    setPortal(document.getElementById('box-portal'))

    if (el && !root) {
      // @hack: 避免存在多个 SubBox，后面的 SubBox mount 时 visible 为 false 导致 root box 不能展示
      // visible toggle from false to true
      if ((visible && !prev.current) || (visible && prev.current && nest)) {
        prev.current = visible
        el.classList.add('hide-root')
      }
      if (!visible && prev.current && !nest) {
        prev.current = visible
        el.classList.remove('hide-root')
      }
    }
    return () => {
      removeStyleSheet(portal as HTMLElement)
      if (
        el &&
        !root &&
        !nest &&
        document.getElementsByClassName('subset-box').length < 2
      ) {
        el.classList.remove('hide-root')
      }
    }
  }, [visible, root, nest])

  if (!visible) return null

  if (rootBox && !root) {
    return (
      <StyleSheetManager target={portal as HTMLElement}>
        <>
          {ReactDOM.createPortal(
            <SubsetBox {...args} title={title}>
              {children}
            </SubsetBox>,
            document.getElementById('box-portal'),
          )}
        </>
      </StyleSheetManager>
    )
  }

  return (
    <StyledBoxContainer className={className}>
      <StyledBox id="box-portal">
        {root ? (
          <RootBox>{children}</RootBox>
        ) : (
          <SubsetBox {...args} title={title}>
            {children}
          </SubsetBox>
        )}
      </StyledBox>
    </StyledBoxContainer>
  )
}
